export function classifyOfferTariff (offer: any): string {
    const components = offer.components;

    for (const component of components) {
        if (component.type === 'tariffMobile') {
            if (component.internalLabel.indexOf(' Data ') > -1) {
                return 'data';
            } else {
                return 'voicedata';
            }
        }
    }

    return 'unknown';
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/classify-offer-tariff.ts